import _ from 'lodash';
import { apiSearch } from './utility';

//- Reducers
/*
export default (state = initialState, action) => {

	switch (action.type) {
		case SEARCHING_STATIONS:
			return {
				...state,
				isSearching: true
			};
		case SEARCH_FAILED:
			return {
				...state,
				searchFailed : true,
			};
		default:
			return state;
	}
};
*/

export const search = (p = {}) => {
	const callback = p.callback || _.noop;
	const onlyLatest = p.onlyLatest;


	return dispatch => {
		apiSearch({
			base : 'opisFtpRecord',
			params : { onlyLatest },
			dispatch : dispatch,
			callback : callback,
		});
	};
};
